import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Tab } from 'semantic-ui-react';

const { Pane } = Tab;

const CaseStatusPane = () =>
    <Pane attached={false}>
        <h2>Widget do sprawdzania statusów spraw przygotowany przez MADKOM SA</h2>
        <h3>Instrukcja instalacji widgetu</h3>
        <p>Aby używać widgetu potrzebna jest biblioteka JQuery. Musimy także dołączyć odpowiedni skrypt na stronie:</p>
        <ul>
            <li>http://api.madkom.pl/widget.js - kod js widgetu (wymagany)</li>
            <li>http://api.madkom.pl/widget.css - podstawowe style (plik ten nie jest wymagany i można samemu ostylować widget od podstaw)</li>
        </ul>
        <p>Aby uruchomić widget należy posiadać identyfikator organizacji i wywołać poniższy kod:</p>
        <SyntaxHighlighter
            language="javascript"
            showLineNumbers>
            {`$('selektor-elementu-w-ktorym-chcemy-osadzic-widget').ezdCaseStatus({organizationId: 'id-organizacji'});`.toString()}
        </SyntaxHighlighter>

        <p>W celu wyświetlenia statystyk spraw zainicjowanych, zamkniętych i w toku należy dodać do widgetu opcjonalny dodatkowy parametr showStats z wartością ustawioną na true</p>
        <SyntaxHighlighter
        language="javascript"
        showLineNumbers>
            {`$('selektor-elementu-w-ktorym-chcemy-osadzic-widget').ezdCaseStatus({organizationId: 'id-organizacji', showStats: true});`.toString()}
        </SyntaxHighlighter>

            <h3>Przykłady</h3>
        <p>W obu przypadkach testowy status to 123.</p>
        <p>Czysty widget z domyślnymi stylami <a href="http://api.madkom.pl/examples/default.html" target="__blank">online</a>:</p>
        <SyntaxHighlighter
            language="html"
            showLineNumbers>
            {`<html>
    <head lang="en">
        <meta charset="UTF-8">
        <title></title>
        <script type="text/javascript" src="https://code.jquery.com/jquery-2.1.4.js"></script>
        <script type="text/javascript" src="http://api.madkom.pl/widget.js"></script>
        <link rel="stylesheet" type="text/css" href="http://api.madkom.pl/widget.css" />
        <script>
            $(document).ready(function(){
                $('#widget-1').ezdCaseStatus({organizationId: 1});
            });
        </script>
    </head>
    <body>
        <div id="widget-1"></div>
    </body>
</html>`.toString()}
        </SyntaxHighlighter>
        <p>Przykład z nadpisanymi stylami <a href="http://api.madkom.pl/examples/custom.html" target="__blank">online</a>:</p>
        <SyntaxHighlighter
            language="html"
            showLineNumbers>
            {`<html>
    <head lang="en">
        <meta charset="UTF-8">
        <title></title>
        <script type="text/javascript" src="https://code.jquery.com/jquery-2.1.4.js"></script>
        <script type="text/javascript" src="http://api.madkom.pl/widget.js"></script>
        <link rel="stylesheet" type="text/css" href="http://api.madkom.pl/widget.css" />
        <link href='http://fonts.googleapis.com/css?family=Roboto:400,900,900italic,700italic,700,500italic,500,400italic,300italic,100,100italic,300&subset=latin,latin-ext' rel='stylesheet' type='text/css'>
        <link href='http://fonts.googleapis.com/css?family=Signika:700,300,400,600&subset=latin,latin-ext' rel='stylesheet' type='text/css'>
        <script>
            $(document).ready(function(){
                $('#widget-1').ezdCaseStatus({organizationId: 1});
            });
        </script>
        <style>
            body { font-family: Roboto; background-color: #e0e0e0; }
            .madkom-ezd-case-status-result { box-shadow: rgba(70,70,70,0.2) 0 2px 0 0; background-color: #fff; padding: 2em; }
            .madkom-ezd-case-status-form { background-color: #fff; padding: 2em; box-sizing: border-box; box-shadow: rgba(70,70,70,0.2) 0 2px 0 0; }
            input { font-size: 16px; color: #df815a; }
            button {
                -webkit-border-radius: 10px;
                -moz-border-radius: 10px;
                -ms-border-radius: 10px;
                -o-border-radius: 10px;
                border-radius: 10px;
                border: none;
                font-size: 16px;
                color: #fff;
                cursor: pointer;
                -webkit-transition: all 0.6s ease;
                -moz-transition: all 0.6s ease;
                -ms-transition: all 0.6s ease;
                -o-transition: all 0.6s ease;
                transition: all 0.6s ease;
                padding: 0.5em; opacity: 0.8;
            }
            button:hover { box-shadow: rgba(70,70,70,0.2) 0 2px 0 0; opacity: 1; }
            button[type="submit"] { background-color: #7dbf94; }
            button[type="reset"] { background-color: #df815a; }
        </style>
    </head>
    <body>
        <div id="widget-1"></div>
    </body>
</html>`.toString()}
        </SyntaxHighlighter>
    </Pane>

export default CaseStatusPane;


// WEBPACK FOOTER //
// ./src/containers/widget/components/CaseStatusPane.js